module.exports = __webpack_public_path__ + "img/chevron-2.68cc4bce.webp";